import { defineMessages } from 'react-intl-next';

export const i18n = defineMessages({
	contributor: {
		id: 'search-page.filters.names.contributor',
		defaultMessage: 'Contributor',
		description: 'Label for filtering by contributor',
	},
	confluenceFilterContributorPlaceholder: {
		id: 'search-page.confluence.filter.contributor.placeholder',
		defaultMessage: 'Find people',
		description: 'Placeholder for contributor filter search input',
	},
	confluenceFilterContributorLabelSelected: {
		id: 'search-page.confluence.filter.contributor.label.selected',
		defaultMessage: 'Selected',
		description: 'Confluence filter label selected',
	},
	confluenceFilterContributorLabelUnselected: {
		id: 'search-page.confluence.filter.contributor.label.unselected',
		defaultMessage: 'Suggested',
		description: 'Confluence filter label unselected',
	},
});
